// extracted by mini-css-extract-plugin
module.exports = {"goTopHidden":"go-top-button-module--goTopHidden--30giQ","goTop":"go-top-button-module--goTop--1FfFz"};